<script>
export default {
    name: "admin",
    data() {
        return {
            dataForm: {
                title: "", // Título de la notificación
                body: "", // Cuerpo del mensaje
                image: null, // Archivo de imagen
                pdf: null, // Archivo PDF
                startDate: "", // Fecha de inicio
                endDate: "", // Fecha de término
                usuarios:[],
            },
            errors: {}, // Para manejar errores de validación
            optionsEstados: [],
            optionsCiudades: [],
            optionsCanales: [],
            optionsCadenas: [],
            optionsFormatos: [],
            optionsTiendas: [],
            todos: false,
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        validateForm() {
            this.errors = {}; // Limpiar errores previos

            // Validación del título
            if (this.dataForm.title.length === 0) {
                this.errors.title = "El título no puede estar vacío.";
            } else if (this.dataForm.title.length > 120) {
                this.errors.title = "El título no debe exceder los 120 caracteres.";
            }

            // Validación del cuerpo
            if (this.dataForm.body.length === 0) {
                this.errors.body = "El cuerpo del mensaje no puede estar vacío.";
            } else if (this.dataForm.body.length > 500) {
                this.errors.body = "El cuerpo del mensaje no debe exceder los 500 caracteres.";
            }

            // Validación de la imagen
            if (this.dataForm.image && !this.dataForm.image.type.startsWith("image/")) {
                this.errors.image = "El archivo seleccionado debe ser una imagen.";
            }

            // Validación del archivo PDF
            if (this.dataForm.pdf && this.dataForm.pdf.type !== "application/pdf") {
                this.errors.pdf = "El archivo seleccionado debe ser un PDF.";
            }

            // Validación de fechas
            if (!this.dataForm.startDate) {
                this.errors.startDate = "La fecha de inicio es obligatoria.";
            }
            if (!this.dataForm.endDate) {
                this.errors.endDate = "La fecha de término es obligatoria.";
            }
            if (this.dataForm.startDate && this.dataForm.endDate && this.dataForm.startDate > this.dataForm.endDate) {
                this.errors.dateRange = "La fecha de inicio no puede ser posterior a la fecha de término.";
            }

            if (this.dataForm.usuarios.length === 0) {
                this.errors.usuarios = "Debe seleccionar al menos un usuario para enviar la notificación.";
            }

            // Si no hay errores, el formulario está validado
            if (Object.keys(this.errors).length === 0) {
                this.submitForm();
            }
        },
        handleImageUpload(event) {
            this.dataForm.image = event.target.files[0];
        },
        handlePdfUpload(event) {
            this.dataForm.pdf = event.target.files[0];
        },
        submitForm() {
            // Aquí podrías enviar los datos al backend
            const formData = new FormData();
            // Agrega los datos al FormData
            formData.append("title", this.dataForm.title);
            formData.append("body", this.dataForm.body);
            formData.append("startDate", this.dataForm.startDate);
            formData.append("endDate", this.dataForm.endDate);
            // Agregar archivos al FormData si existen
            if (this.dataForm.image) {
                formData.append("image", this.dataForm.image);
            }
            if (this.dataForm.pdf) {
                formData.append("pdf", this.dataForm.pdf);
            }
            // Agregar campos adicionales (listas, arrays)
            formData.append("usuarios", JSON.stringify(this.dataForm.usuarios));

            // Enviar los datos al backend usando Axios
            axios
                .post("/api/WebServices/storeNotification", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    console.log("Formulario enviado exitosamente:", response.data);
                    // Manejar respuesta exitosa
                    this.$toastMessage("success", "Notificación enviada exitosamente", 4000, "center");
                })
                .catch(error => {
                    console.error("Error al enviar el formulario:", error.response.data);
                    // Manejar errores
                    this.$toastMessage("error", "Error al enviar la notificación", 4000, "center");

                    // Si hay errores devueltos del backend, los puedes agregar aquí
                    if (error.response && error.response.data.errors) {
                        this.errors = error.response.data.errors;
                    }
                });

        },
        getEstados(){
            axios
                .post('/api/Encuestas/Peticiones',{combo:3})
                .then(response => (this.optionsEstados = response.data));
        },
        getData(){
                this.optionsEstados=[]
                this.optionsCiudades=[]
                this.optionsCanales=[]
                this.optionsCadenas=[]
                this.optionsFormatos=[]
                this.optionsTiendas=[]
                this.dataForm.fechaInicio = null
            this.dataForm.fechaFin = null
            this.dataForm.areas= []
            this.dataForm.agencia=[]
            this.dataForm.estados=[]
            this.dataForm.ciudades=[]
            this.dataForm.canales=[]
            this.dataForm.cadenas=[]
            this.dataForm.formatos=[]
            this.dataForm.tiendas=[]

            this.dataForm.image=null
            this.dataForm.pdf=null
            this.dataForm.startDate = null
            this.dataForm.endDate = null
            this.getEstados()
            this.getCiudades()
            this.getCanales()
            this.getCadenas()
            this.getFormatos()
        },
        getCiudades(){
            axios
                .post('/api/Encuestas/Peticiones',{combo:4})
                .then(response => (this.optionsCiudades = response.data));
        },
        changeCanal(){
            this.dataForm.cadenas = [];
            this.dataForm.formatos = [];
            this.dataForm.tiendas = [];
            this.optionsCadenas = [];
            this.optionsFormatos = [];
            this.optionsTiendas = [];
            axios
                .post('/api/Encuestas/Peticiones',{combo:6,canales:this.dataForm.canales})
                .then(response => (this.optionsCadenas = response.data));

        },
        getCanales(){
            axios
                .post('/api/Encuestas/Peticiones',{combo:5})
                .then(response => (this.optionsCanales = response.data));
        },
        getCadenas(){
            axios
                .post('/api/Encuestas/Peticiones',{combo:6})
                .then(response => (this.optionsCadenas = response.data));
        },
        getFormatos(){
            axios
                .post('/api/Encuestas/Peticiones',{combo:7})
                .then(response => (this.optionsFormatos = response.data))
        },
        changeEstados(){
            this.dataForm.ciudades = [];
            this.optionsCiudades = [];
            axios
                .post('/api/Encuestas/Peticiones',{combo:4,estados:this.dataForm.estados})
                .then(response => (this.optionsCiudades = response.data));
        },
        changeCiudades(){
            this.dataForm.formatos = [];
            this.dataForm.tiendas = [];
            this.optionsTiendas = [];
        },
        changeFormato(){
            if (this.dataForm.formatos.length>0){
                if (this.dataForm.ciudades.length<1){
                    this.dataForm.formatos = []
                    this.$toastMessage("error","Por favor seleccione por lo menos una ciudad!, para traer las tiendas correspondientes a los formatos seleccionados!",4000,'center');
                }
                else
                {
                    let $this = this;
                    this.dataForm.tiendas = []
                    this.optionsTiendas = []
                    this.usuarios = []

                    axios
                        .post('/api/WebServices/getUsersNotificaciones',{
                            formatos: this.dataForm.formatos,
                            ciudades: this.dataForm.ciudades,
                            all: false
                        })
                        .then(function ({data}){
                            $this.dataForm.usuarios = data.Usuarios
                        });
                }
            }else{
                this.optionsTiendas = [];
                this.dataForm.ciudades = [];
            }
        },
        changeCadena(){
            this.dataForm.formatos = [];
            this.dataForm.tiendas = [];
            this.optionsFormatos = [];
            this.optionsTiendas = [];
            axios
                .post('/api/Encuestas/Peticiones',{combo:7,cadenas:this.dataForm.cadenas})
                .then(response => (this.optionsFormatos = response.data))
        },
        getAllUsers(){
            if (!this.todos){
                let $this = this
                this.usuarios = []
                axios
                    .post('/api/WebServices/getUsersNotificaciones',{
                        all: true,
                    })
                    .then(function ({data}){
                        $this.dataForm.usuarios = data.Usuarios
                    });
                this.todos = true
            }
            else {
                this.todos = false
                this.dataForm.usuarios = []
            }

        }
    }

}
</script>

<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-3">
                <h1 class="mb-4">Datos de la notificación</h1>
                    <!-- Campo Título -->
                    <div class="form-group">
                        <label for="title">Título</label>
                        <input
                            type="text"
                            id="title"
                            class="form-control"
                            v-model="dataForm.title"
                            maxlength="120"
                        />
                        <small class="text-danger" v-if="errors.title">{{ errors.title }}</small>
                    </div>

                    <!-- Campo Cuerpo -->
                    <div class="form-group">
                        <label for="body">Cuerpo del mensaje</label>
                        <textarea
                            id="body"
                            class="form-control"
                            v-model="dataForm.body"
                            maxlength="500"
                            rows="4"
                        ></textarea>
                        <small class="text-danger" v-if="errors.body">{{ errors.body }}</small>
                    </div>

                    <!-- Campo Fecha de Inicio -->
                    <div class="form-group">
                        <label for="start-date">Fecha de Inicio</label>
                        <input
                            type="date"
                            id="start-date"
                            class="form-control"
                            v-model="dataForm.startDate"
                        />
                        <small class="text-danger" v-if="errors.startDate">{{ errors.startDate }}</small>
                    </div>

                    <!-- Campo Fecha de Término -->
                    <div class="form-group">
                        <label for="end-date">Fecha de Término</label>
                        <input
                            type="date"
                            id="end-date"
                            class="form-control"
                            v-model="dataForm.endDate"
                        />
                        <small class="text-danger" v-if="errors.endDate">{{ errors.endDate }}</small>
                        <small class="text-danger" v-if="errors.dateRange">{{ errors.dateRange }}</small>
                    </div>

                    <!-- Input para imágenes -->
                    <div class="form-group">
                        <label for="image-upload">Subir Imagen</label>
                        <input
                            type="file"
                            id="image-upload"
                            class="form-control"
                            @change="handleImageUpload"
                            accept="image/*"
                        />
                        <small class="text-danger" v-if="errors.image">{{ errors.image }}</small>
                    </div>

                    <!-- Input para PDFs -->
                    <div class="form-group">
                        <label for="pdf-upload">Subir PDF</label>
                        <input
                            type="file"
                            id="pdf-upload"
                            class="form-control"
                            @change="handlePdfUpload"
                            accept="application/pdf"
                        />
                        <small class="text-danger" v-if="errors.pdf">{{ errors.pdf }}</small>
                    </div>

                    <!-- Botón de envío -->
                    <button type="submit" class="btn btn-primary" @click="validateForm">Enviar</button>
            </div>
            <div class="col-4">
                <h1 class="mb-4">Buscar usuarios a notificar {{ dataForm.usuarios.length }}</h1>
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Estados: <b>{{optionsEstados.length-1}}/{{optionsEstados.length}}</b></label>
                            <v-select :multiple="true" :options="optionsEstados" :placeholder="'Selecciona Estados'" v-model="dataForm.estados" @input="changeEstados"></v-select>
                            <br>
                            <label>Ciudades: <b>{{optionsCiudades.length-1}}/{{optionsCiudades.length}}</b></label>
                            <v-select :multiple="true" :options="optionsCiudades" :placeholder="'Selecciona Ciudad'" v-model="dataForm.ciudades" @input="changeCiudades"></v-select>
                        </div>
                        <div class="col-md-4">
                            <label>Canales: <b>{{optionsCanales.length-1}}/{{optionsCanales.length}}</b></label>
                            <v-select :multiple="true" :options="optionsCanales" :placeholder="'Selecciona Canal'" v-model="dataForm.canales" @input="changeCanal"></v-select>
                            <br>
                            <label>Cadena: <b>{{optionsCadenas.length-1}}/{{optionsCadenas.length}}</b></label>
                            <v-select :multiple="true" :options="optionsCadenas" :placeholder="'Selecciona Canal'" v-model="dataForm.cadenas" @input="changeCadena"></v-select>
                            <br>
                            <label>Formatos: <b>{{optionsFormatos.length-1}}/{{optionsFormatos.length}}</b></label>
                            <v-select :multiple="true" :options="optionsFormatos" :placeholder="'Selecciona Formato'" v-model="dataForm.formatos" @input="changeFormato"></v-select>
                        </div>
                        <div class="col-md-4 text-center">
                            <p-check class="p-default p-curve p-thick p-smooth" color="danger-o" @click.native="getAllUsers">Enviar a todos los usuarios</p-check>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.container {
    max-width: 600px;
}

</style>
